import { TextSwitcherItem, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledCrmEnrichmentJobSwitcher } from "./styles";

interface IProps<T> {
    options: readonly T[];
    selectedOption: T;
    customClass?: string;
    isDisabled?: boolean;
    tooltipKeys?: string[];
    getTranslationKey: (option: T) => string;
    onSelectOption?: (option: T) => void;
}

const JobSwitcher = <T extends string>({
    options,
    selectedOption,
    onSelectOption,
    getTranslationKey,
    customClass = "TextSwitcher",
    isDisabled,
    tooltipKeys,
}: IProps<T>) => {
    return (
        <StyledCrmEnrichmentJobSwitcher
            selectedIndex={options.indexOf(selectedOption)}
            customClass={customClass}
            onItemClick={onSelectOption ? (index: number) => onSelectOption(options[index]) : undefined}
        >
            {options.map((option, index) => {
                const tooltipKey = tooltipKeys && tooltipKeys[index];

                return (
                    <TextSwitcherItem
                        key={option}
                        disabled={!!(isDisabled && option !== selectedOption)}
                    >
                        <Tooltip
                            placement="top"
                            enabled={!!tooltipKey}
                            content={
                                <I18n
                                    translatable={{
                                        key: tooltipKey || "",
                                    }}
                                />
                            }
                        >
                            <span>{translate(getTranslationKey(option))}</span>
                        </Tooltip>
                    </TextSwitcherItem>
                );
            })}
        </StyledCrmEnrichmentJobSwitcher>
    );
};

export default JobSwitcher;
